import { Conversation } from '@twilio/conversations'

export const getParticipantIdsByConversation = async (conversation: Conversation): Promise<(string | null)[]> => {
  const participants = await conversation.getParticipants()
  const participantsIds = participants.map(participant => participant.identity)

  return participantsIds
}

export const getConversationDisplayName = async (conversation: Conversation, users: MData.User[], currentUserId?: string): Promise<string | null> => {
  const participantsIds = await getParticipantIdsByConversation(conversation)

  const participantUsers = users
    .filter(user => {
      return participantsIds.includes(user._id)
    })
    .filter(user => user._id !== currentUserId)

  if (!participantUsers.length) {
    return null
  }
  const [first, second, third, ...rest] = participantUsers
  return `${[first?.fullName, second?.fullName, third?.fullName].filter(Boolean).join(', ')}${rest.length ? ` + ${rest.length} ` : ''}`
}
